// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import type {
  TacticalMeetingChecklistItemsView_circle as Circle,
} from './__generated__/TacticalMeetingChecklistItemsView_circle.graphql'

type Props = $ReadOnly<{
  circle: Circle,
}>

function TacticalMeetingChecklistItemsView({circle}: Props): Node {
  const roleDatabaseId = circle.supportedRole ? circle.supportedRole.databaseId : null

  if (!roleDatabaseId)
    return null

  return (
    <turbo-frame
      id="content-frame"
      src={`/organizations/${circle.organization.databaseId}/roles/${roleDatabaseId}/checklist_items${window.location.search}`}
    />
  )
}

export default (createFragmentContainer(TacticalMeetingChecklistItemsView, {
  circle: graphql`
    fragment TacticalMeetingChecklistItemsView_circle on Circle {
      databaseId
      
      organization {
        id
        databaseId
      }

      supportedRole {
        databaseId
      }
    }
  `,
}): RelayFragmentContainer<typeof(TacticalMeetingChecklistItemsView)>)
